/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoveltyCalcAffectedProduct
 */
export interface NoveltyCalcAffectedProduct {
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcAffectedProduct
     */
    productId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NoveltyCalcAffectedProduct
     */
    priceUnitId?: number | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof NoveltyCalcAffectedProduct
     */
    detail?: { [key: string]: string; } | null;
}

/**
 * Check if a given object implements the NoveltyCalcAffectedProduct interface.
 */
export function instanceOfNoveltyCalcAffectedProduct(value: object): value is NoveltyCalcAffectedProduct {
    return true;
}

export function NoveltyCalcAffectedProductFromJSON(json: any): NoveltyCalcAffectedProduct {
    return NoveltyCalcAffectedProductFromJSONTyped(json, false);
}

export function NoveltyCalcAffectedProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoveltyCalcAffectedProduct {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'] == null ? undefined : json['productId'],
        'priceUnitId': json['priceUnitId'] == null ? undefined : json['priceUnitId'],
        'detail': json['detail'] == null ? undefined : json['detail'],
    };
}

export function NoveltyCalcAffectedProductToJSON(json: any): NoveltyCalcAffectedProduct {
    return NoveltyCalcAffectedProductToJSONTyped(json, false);
}

export function NoveltyCalcAffectedProductToJSONTyped(value?: NoveltyCalcAffectedProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'priceUnitId': value['priceUnitId'],
        'detail': value['detail'],
    };
}

